import { useTraduccion } from '@tallerya/i18n';
import './listado.css';

/**
 * El control del pie de la tabla: `‹ ›`.
 *
 * ## Por qué no hay números de página
 *
 * El Figma dibujaba `‹ 1 2 3 ›`, y para eso hace falta el total de filas. La API
 * no lo devuelve **a propósito**: contar obliga a una segunda consulta que
 * recorre justo lo que el cursor existe para no recorrer, y el razonamiento
 * completo está en `CursorPage.cs`. Una lista no necesita saber cuántas filas
 * hay; necesita saber si hay una más.
 *
 * Así que la pantalla no dice en qué página está —no lo sabe— sino si puede ir
 * hacia adelante y hacia atrás. `hayMas` es el `hasMore` de `CursorPage`, tal
 * cual viene.
 *
 * **Volver atrás es de la pantalla, no de acá.** El cursor apunta hacia
 * adelante: para retroceder hay que recordar los cursores por los que ya se
 * pasó, y eso vive en quien hace las consultas. Este componente solo pregunta si
 * se puede.
 */
export function Paginacion({
  hayAnterior,
  hayMas,
  onAnterior,
  onSiguiente,
}: {
  /** Si hay páginas anteriores a las que volver. */
  hayAnterior: boolean;
  /** Si hay más filas después de estas. */
  hayMas: boolean;
  onAnterior: () => void;
  onSiguiente: () => void;
}) {
  const { t } = useTraduccion();

  return (
    <nav className="ui-paginacion" aria-label={t('ui.listado.paginacion')}>
      <button
        type="button"
        aria-label={t('ui.listado.paginaAnterior')}
        disabled={!hayAnterior}
        onClick={onAnterior}
      >
        ‹
      </button>
      <button
        type="button"
        aria-label={t('ui.listado.paginaSiguiente')}
        disabled={!hayMas}
        onClick={onSiguiente}
      >
        ›
      </button>
    </nav>
  );
}
